module.exports = __webpack_public_path__ + "static/media/pie-chart.f537826f.png";